import { ICON_SLUGS, iconUrl, type IconSlug } from '../lib/icons';

/**
 * Grid of all available pixel icons for a category. The cells are plain
 * buttons so keyboard navigation (Tab + Enter/Space) Just Works.
 */
export function IconPicker({
  value,
  onChange,
}: {
  value: IconSlug | null;
  onChange: (slug: IconSlug | null) => void;
}) {
  return (
    <div className="icon-picker">
      <button
        type="button"
        className={'icon-picker__cell icon-picker__none' + (value === null ? ' icon-picker__cell--selected' : '')}
        onClick={() => onChange(null)}
        aria-pressed={value === null}
        aria-label="no icon"
      >
        —
      </button>
      {ICON_SLUGS.map(slug => (
        <button
          key={slug}
          type="button"
          className={'icon-picker__cell' + (value === slug ? ' icon-picker__cell--selected' : '')}
          onClick={() => onChange(slug)}
          aria-pressed={value === slug}
          aria-label={slug}
          title={slug.replace(/-/g, ' ')}
        >
          <img
            src={iconUrl(slug) ?? ''}
            alt=""
            width={32}
            height={32}
            style={{ imageRendering: 'pixelated', objectFit: 'contain' }}
          />
        </button>
      ))}
    </div>
  );
}
